/** All rows share an absolute axis: bpm for heart rate, km/h for speed. */
export function trainingZoneScale(kind: 'heart' | 'pace', zones: Array<{ maximum: number }>) {
  const factor = kind === 'pace' ? 3.6 : 1;
  const step = kind === 'pace' ? 5 : 20;
  const maximum = Math.max(step, ...zones.map(zone => Number.isFinite(zone.maximum) ? zone.maximum * factor : 0));
  return { maximum: Math.ceil(maximum / step) * step, factor };
}

export function trainingZoneFill(maximum: number, factor: number, scale: number) {
  return Number.isFinite(maximum) && scale > 0 ? Math.min(100, Math.max(0, maximum * factor / scale * 100)) : 0;
}
